/** Constants for the namespace feature. */

// ─── String groups table ────────────────────────────────────────────────────

/** Number of string groups to display per page (client-side pagination). */
export const STRING_GROUPS_PAGE_SIZE = 25;

/** Number of string groups to fetch per backend call. */
export const STRING_GROUPS_FETCH_BATCH_SIZE = 100;

/** Number of initial batches to fetch on mount (5 × 100 = 500 items). */
export const STRING_GROUPS_INITIAL_BATCHES = 5;

/** Debounce (ms) for the string groups server-side prefix search.
 * Set to 600ms to reduce API call volume on slower typists while keeping
 * perceived latency acceptable. */
export const STRING_GROUPS_SEARCH_DEBOUNCE_MS = 600;

// ─── Create String Group form ───────────────────────────────────────────────

/** Maximum character length for the string group name field. */
export const SG_NAME_MAX_LENGTH = 128;

/** Maximum character length for the string group description field. */
export const SG_DESCRIPTION_MAX_LENGTH = 500;
